const securityItems = [
  { title: 'Data Protection', description: 'Vigorbuy Spreadsheet implements robust data encryption and access controls to keep your business information secure at all times.' },
  { title: 'Privacy', description: 'Your spreadsheet data remains private and under your control. No unauthorized third-party access to your files or information.' },
  { title: 'Secure Usage', description: 'Follow recommended security practices including strong passwords, limited sharing permissions, and regular data backups.' },
  { title: 'File Safety', description: 'Always download Vigorbuy Spreadsheet files from official sources. Verify file integrity before opening shared spreadsheets.' },
  { title: 'User Responsibility', description: 'While the platform provides security features, users should maintain good data hygiene — back up important files and use unique passwords.' },
];

export default function SecuritySection() {
  return (
    <section className="py-16 md:py-20 bg-background-100/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold tracking-wide mb-4">
            Security
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl text-foreground-950 mb-4">
            Is Vigorbuy Spreadsheet Safe?
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto">
            We take security seriously. Here is what you need to know about keeping your data protected while using Vigorbuy Spreadsheet.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-10">
          {securityItems.slice(0, 3).map((item) => (
            <div key={item.title} className="bg-background-50 border border-background-200/60 rounded-2xl p-6">
              <div className="w-10 h-10 rounded-xl bg-secondary-100 flex items-center justify-center mb-4">
                <i className="ri-shield-check-line text-secondary-600 text-lg"></i>
              </div>
              <h3 className="font-heading text-base text-foreground-950 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 max-w-3xl mx-auto">
          {securityItems.slice(3).map((item) => (
            <div key={item.title} className="bg-background-50 border border-background-200/60 rounded-2xl p-6">
              <div className="w-10 h-10 rounded-xl bg-secondary-100 flex items-center justify-center mb-4">
                <i className="ri-shield-user-line text-secondary-600 text-lg"></i>
              </div>
              <h3 className="font-heading text-base text-foreground-950 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 max-w-2xl mx-auto bg-background-50 border border-background-200/60 rounded-2xl overflow-hidden">
          <table className="w-full">
            <thead>
              <tr className="border-b border-background-200/60">
                <th className="text-left px-6 py-3 text-sm font-semibold text-foreground-800">Security Factor</th>
                <th className="text-left px-6 py-3 text-sm font-semibold text-foreground-800">Recommendation</th>
              </tr>
            </thead>
            <tbody>
              {[
                { factor: 'Data Backup', rec: 'Always backup important files regularly' },
                { factor: 'Password', rec: 'Use strong, unique passwords for your account' },
                { factor: 'Sharing', rec: 'Limit access to trusted collaborators only' },
                { factor: 'Downloads', rec: 'Always verify sources before downloading files' },
              ].map((row, idx) => (
                <tr key={row.factor} className={`border-b border-background-200/30 ${idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100/40'}`}>
                  <td className="px-6 py-3 text-sm font-medium text-foreground-800">{row.factor}</td>
                  <td className="px-6 py-3 text-sm text-foreground-600">{row.rec}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}